import axios from "axios";
import * as RO from "./ReportObjects.js";
let access_token = null;
let refresh_token = null;
let start_system_promise = null;

/* LIVE! */
let api_gateway = 'https://api-gateway.maritrace.com/api';

export const post_data = async (endpoint, request_data) => {
	if(access_token == null){
		// Concurrent first calls must share one token bootstrap, or each spawns its own refresh timer chain
		if(start_system_promise == null){
			start_system_promise = startSystem().catch((error) => { start_system_promise = null; throw error; });
		}
		await start_system_promise;
	}
	const api_endpoint = api_gateway + "/microservice" + endpoint;
	let api_response = null;
	let response = null;
	try {
		const headers = {
			'Authorization': 'Bearer ' + access_token
		};
		api_response = await axios.post(api_endpoint, request_data, { headers });

		response = api_response.data;

		if (response.payload){
			response = response.payload;
		}
		if(response.Items){
			response = response.Items;
		}

	} catch (error) {
		throw new Error(`API request failed: ${error.message}`);
	}

	return response;
};

async function retrieveTokens() {
    try {
        let requestBody = {
            "key" : "report_system_AccessKeyId",
            "userID" : "AIDAZ4E7PMP52BTA2O4JI",
        };
        let response = await axios.post(api_gateway + '/validateAPI/get_api_security_key', requestBody);
        const value = response.data.value;

        const validateBody = {
            "SystemName": "report_system",
            "UserId": "AIDAZ4E7PMP52BTA2O4JI",
            "AccessKeyId": value,
        };

        response = await axios.post(api_gateway + '/validate-system-new', validateBody);
        const payload = response.data.payload;

        access_token = payload['ACTIVE Token'];
        refresh_token = payload['REFRESH Token'];
        setTimeout(refreshAccessToken, 60 * 60 * 500);
    } catch (error) {
        console.error('Error retrieving tokens:', error);
        throw error;
    }
}
async function refreshAccessToken() {
  try {
    const response = await axios.get(api_gateway + '/active_token', {
         headers: {
             Authorization: `Bearer ${refresh_token}`
         }
     });

    const payload = response.data.payload;
    access_token = payload['active_token'];

    setTimeout(refreshAccessToken, 60 * 60 * 500);
  } catch (error) {
    console.error('Error refreshing access token:', error);
    throw error;
  }
}
function scheduleRefreshRefreshToken() {
  const now = new Date();
  const tomorrow = new Date(now);
  tomorrow.setDate(now.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);

  setTimeout(refreshRefreshToken, 60 * 60 * 1000 * 24);
}
async function refreshRefreshToken() {
  try {
    const response = await axios.get(api_gateway + '/refresh_token', {
        headers: {
            Authorization: `Bearer ${access_token}`
        }
    });

    const payload = response.data.payload;
    refresh_token = payload['refresh_token'];

    scheduleRefreshRefreshToken();
  } catch (error) {
    console.error('Error refreshing refresh token:', error);
    throw error;
  }
}

async function startSystem() {
  await retrieveTokens(); // Initial token acquisition
  scheduleRefreshRefreshToken(); // Schedule refresh of refresh token every day
}
